export function EmptyElement() {
    return (
        <></>
    );
}
